<div id="seedBank" class="row justify-content-between mx-0" *ngIf="label">

  <div class="col-12 col-lg-3 py-3 pr-md-4">

    <div class="filterControl">
      <div class="mb-3 mb-md-4">

        <div class="d-none d-lg-block">
          <label>{{ label[lang].species }}</label>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="spec01" [(ngModel)]="speciesAll"
              (ngModelChange)="speciesAllOnChange()">
            <label class="custom-control-label" for="spec01">
              {{ label[lang].allSpecies }}
            </label>
          </div>
          <div class="custom-control custom-checkbox" *ngFor="let spec of species">
            <input type="checkbox" class="custom-control-input" [id]="'spec' + spec.labelTc"
              [(ngModel)]="speciesFilter[spec.labelTc]" (ngModelChange)="speciesFilterOnChange()">
            <label class="custom-control-label" [for]="'spec' + spec.labelTc">
              <ng-container *ngIf="lang === 'tc'">
                {{ spec.labelTc }}
              </ng-container>
              <ng-container *ngIf="lang === 'sc'">
                {{ spec.labelSc }}
              </ng-container>
              <ng-container *ngIf="lang === 'en'">
                {{ spec.labelEn }}
              </ng-container>
            </label>
          </div>
        </div>

        <div class="p-fluid d-bock d-lg-none">
          <p-multiSelect [options]="species" optionLabel="labelTc" appendTo="body" [filter]="false"
            (onChange)="speciesMultiSelectOnChange($event)" [defaultLabel]="label[lang].species" maxSelectedLabels="6"
            selectedItemsLabel="{{ label[lang].selected }} {0} {{ label[lang].species }}">
          </p-multiSelect>
        </div>

      </div>
      <div>

        <div class="d-none d-lg-block">
          <label>{{ label[lang].season }}</label>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="season01" [(ngModel)]="seasonAll"
              (ngModelChange)="seasonAllOnChange()">
            <label class="custom-control-label" for="season01">
              {{ label[lang].allSeason }}
            </label>
          </div>
          <div class="custom-control custom-checkbox" *ngFor="let s of season">
            <input type="checkbox" class="custom-control-input" [id]="'season' + s.labelTc"
              [(ngModel)]="seasonFilter[s.labelTc]" (ngModelChange)="seasonFilterOnChange()">
            <label class="custom-control-label" [for]="'season' + s.labelTc">
              <ng-container *ngIf="lang === 'tc'">
                {{ s.labelTc }}
              </ng-container>
              <ng-container *ngIf="lang === 'sc'">
                {{ s.labelSc }}
              </ng-container>
              <ng-container *ngIf="lang === 'en'">
                {{ s.labelEn }}
              </ng-container>
            </label>
          </div>
        </div>

        <div class="p-fluid d-bock d-lg-none">
          <p-multiSelect [options]="season" optionLabel="labelTc" appendTo="body" [filter]="false"
            (onChange)="seasonMultiSelectOnChange($event)" [defaultLabel]="label[lang].season" maxSelectedLabels="6"
            selectedItemsLabel="{{ label[lang].selected }} {0} {{ label[lang].season }}">
          </p-multiSelect>
        </div>

      </div>
    </div>

  </div>

  <div class="col-12 col-lg-9 py-3 mb-3" *ngIf="!showSeedDetails">
    <div class="row">
      <div class="col">
        <div id="pageTitle" class="pageTitle">
          {{ label[lang].seedBank }}
        </div>
      </div>
      <div class="col-auto">
        <button class="btn btn-success btn-sm backBtn" (click)="backShowSeedCat()" *ngIf="!showSeedCat">
          {{ label[lang].prevPage }}
        </button>
      </div>
    </div>

    <!-- show cat -->
    <div class="row" *ngIf="showSeedCat">
      <div class="col-6 col-lg-4 col-xl-3" *ngFor="let seedCat of seedCatData; let key = index;">
        <div class="seedCat" (click)="setSeedCat(seedCat.breedTc)">
          <div *ngFor="let src of imageListSort(seedCat.images); let imgIdx = index;">
            <img class="img-fluid mx-auto" [src]="src" *ngIf="imgIdx === 0" />
          </div>
          <div class="catName">

            <ng-container *ngIf="lang === 'tc'">
              {{ seedCat.breedTc }}
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              {{ seedCat.breedSc }}
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              {{ seedCat.breedEn }}
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-12 py-3" *ngIf="seedCatData.length < 1">
        {{ label[lang].noResult }}
      </div>
    </div>

    <!-- show cat inner -->
    <div class="row" *ngIf="!showSeedCat">
      <div class="col-6 col-lg-4 col-xl-3" *ngFor="let seed of seedData; let key = index;">
        <div class="seedCat" (click)="setSeedDetails(seed.code)">
          <div>

            <!-- <img class="img-fluid mx-auto" [src]="src" *ngFor="let src of seed.images" /> -->

            <ng-container *ngFor="let src of imageListSort(seed.images); let i = index;">
              <img class="img-fluid mx-auto" [src]="src" *ngIf="i === 1" />
            </ng-container>

            <!-- <img class="img-fluid mx-auto" src="https://via.placeholder.com/300x150" /> -->

            <!-- <img class="img-fluid mx-auto" src="https://via.placeholder.com/300x150" /> -->

          </div>
          <div class="catName">

            <ng-container *ngIf="lang === 'tc'">
              {{ seed.nameTc }}
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              {{ seed.nameSc }}
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              {{ seed.nameEn }}
            </ng-container>
          </div>
          <div class="catDesc">
            {{ label[lang].plantingSeason }} :
            <ng-container *ngIf="lang === 'tc'">
              <!-- {{ seed.seasonTc }} -->
              {{ seed.season2SearchTc }}
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              <!-- {{ seed.seasonSc }} -->
              {{ seed.season2SearchSc }}
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              <!-- {{ seed.seasonEn }} -->
              {{ seed.season2SearchEn }}
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="seedData.length < 1">
        {{ label[lang].noResult }}
      </div>
    </div>

    <div class="pb-3">
      <!-- <small>{{ label[lang].commonRemark }}</small> -->
      <small>{{ label[lang].seedbankRemark1 }}</small>
      <br />
      <small>{{ label[lang].seedbankRemark2 }}</small>
      <br />
      <small>{{ label[lang].seedbankRemark3 }}</small>
    </div>

  </div>

  <div class="col-12 col-lg-9 py-3 mb-3" *ngIf="showSeedDetails && seedDetails">
    <div class="row">

      <div class="col-12">
        <div class="row">
          <div class="col">
            <div id="pageTitle" class="pageTitle">
              <ng-container *ngIf="lang === 'tc'">
                {{ seedDetails.nameTc }}
              </ng-container>
              <ng-container *ngIf="lang === 'sc'">
                {{ seedDetails.nameSc }}
              </ng-container>
              <ng-container *ngIf="lang === 'en'">
                {{ seedDetails.nameEn }}
              </ng-container>
            </div>
          </div>
          <div class="col-auto">
            <button class="btn btn-success btn-sm backBtn" (click)="seedDetailsBackBtn()">
              {{ label[lang].prevPage }}
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 col-md order-1 order-md-0">

        <div class="dataWrap">
          <table class="seedData">
            <tr>
              <th width="180">{{ label[lang].branch }}</th>
              <td>
                <ng-container *ngIf="lang === 'tc'">
                  {{ seedDetails.branchTc }}
                </ng-container>
                <ng-container *ngIf="lang === 'sc'">
                  {{ seedDetails.branchSc }}
                </ng-container>
                <ng-container *ngIf="lang === 'en'">
                  {{ seedDetails.branchEn }}
                </ng-container>
              </td>
            </tr>
            <tr>
              <th>{{ label[lang].nameTc }}</th>
              <td>{{ seedDetails.nameTc }}</td>
            </tr>
            <tr>
              <th>{{ label[lang].nameEn }}</th>
              <td>{{ seedDetails.nameEn }}</td>
            </tr>
            <tr>
              <th>{{ label[lang].scientificName }}</th>
              <td [innerHTML]="sciNameItalic(seedDetails.sciName)">
              </td>
            </tr>
          </table>
        </div>

        <!-- <div class="pageTitle">
          {{ label[lang].variety }} :
          <ng-container *ngIf="lang === 'tc'">
            {{ seedDetails.breedTc }}
          </ng-container>
          <ng-container *ngIf="lang === 'sc'">
            {{ seedDetails.breedTSc }}
          </ng-container>
          <ng-container *ngIf="lang === 'en'">
            {{ seedDetails.breedTEn }}
          </ng-container>
        </div> -->
        <div class="dataWrap">
          <table class="seedData">
            <tr>
              <th width="180">SeedTec {{ label[lang].code }}</th>
              <td>{{ seedDetails.code }}</td>
            </tr>
            <tr>
              <th>{{ label[lang].character }}</th>
              <td>
                <ng-container *ngIf="lang === 'tc'">
                  {{ seedDetails.varietyTc }}
                </ng-container>
                <ng-container *ngIf="lang === 'sc'">
                  {{ seedDetails.varietySc }}
                </ng-container>
                <ng-container *ngIf="lang === 'en'">
                  {{ seedDetails.varietyEn }}
                </ng-container>
              </td>
            </tr>
            <!-- <tr>
              <th>{{ label[lang].crop }}</th>
              <td>
                <ng-container *ngIf="lang === 'tc'">
                  {{ seedDetails.cropTc }}
                </ng-container>
                <ng-container *ngIf="lang === 'sc'">
                  {{ seedDetails.cropSc }}
                </ng-container>
                <ng-container *ngIf="lang === 'en'">
                  {{ seedDetails.cropEn }}
                </ng-container>
              </td>
            </tr> -->
            <tr>
              <th>{{ label[lang].plantingSeason }}</th>
              <td>
                <ng-container *ngIf="lang === 'tc'">
                  {{ seedDetails.season2SearchTc }}
                  <ng-container *ngIf="seedDetails.seasonTc">
                    ({{ seedDetails.seasonTc }})
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="lang === 'sc'">
                  {{ seedDetails.season2SearchSc }}
                  <ng-container *ngIf="seedDetails.seasonSc">
                    ({{ seedDetails.seasonSc }})
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="lang === 'en'">
                  {{ seedDetails.season2SearchEn }}
                  <ng-container *ngIf="seedDetails.seasonEn">
                    ({{ seedDetails.seasonEn }})
                  </ng-container>
                </ng-container>
              </td>
            </tr>
            <tr>
              <th>{{ label[lang].plantingTec }}</th>
              <td>
                <ng-container *ngIf="lang === 'tc'">
                  {{ seedDetails.techTc }}
                </ng-container>
                <ng-container *ngIf="lang === 'sc'">
                  {{ seedDetails.techSc }}
                </ng-container>
                <ng-container *ngIf="lang === 'en'">
                  {{ seedDetails.techEn }}
                </ng-container>
              </td>
            </tr>
            <!-- <tr>
              <th>{{ label[lang].markerInfo }}</th>
              <td>
                <ng-container *ngIf="lang === 'tc'">
                  {{ seedDetails.markerTc }}
                </ng-container>
                <ng-container *ngIf="lang === 'sc'">
                  {{ seedDetails.markerSc }}
                </ng-container>
                <ng-container *ngIf="lang === 'en'">
                  {{ seedDetails.markerEn }}
                </ng-container>
              </td>
            </tr> -->
            <tr>
              <th>{{ label[lang].source }}</th>
              <td>
                <ng-container *ngIf="lang === 'tc'">
                  {{ seedDetails.originTc }}
                </ng-container>
                <ng-container *ngIf="lang === 'sc'">
                  {{ seedDetails.originSc }}
                </ng-container>
                <ng-container *ngIf="lang === 'en'">
                  {{ seedDetails.originEn }}
                </ng-container>
              </td>
            </tr>
          </table>
        </div>
        <div class="dataLink">
          {{ label[lang].attributes }} :
          <a (click)="attrCatOnClick(seedDetails.catTc)" href="javascript:void(0)">
            <ng-container *ngIf="lang === 'tc'">
              {{ seedDetails.catTc }}
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              {{ seedDetails.catSc }}
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              {{ seedDetails.catEn }}
            </ng-container>
          </a>,
          <!-- <a (click)="attrSeasonOnClick(seedDetails.seasonTc)" href="javascript:void(0)">
            <ng-container *ngIf="lang === 'tc'">
              {{ seedDetails.seasonTc }}
            </ng-container>
            <ng-container *ngIf="lang === 'sc'">
              {{ seedDetails.seasonSc }}
            </ng-container>
            <ng-container *ngIf="lang === 'en'">
              {{ seedDetails.seasonEn }}
            </ng-container>
          </a> -->

          <ng-container *ngIf="lang === 'tc'">
            <ng-container *ngFor="let season of attrSearch2SearchList(seedDetails.season2SearchTc); let key = index">
              <ng-container *ngIf="key > 0">
                ,
              </ng-container>
              <a (click)="attrSeasonOnClick(season)" href="javascript:void(0)">
                {{ season }}
              </a>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="lang === 'sc'">
            <ng-container *ngFor="let season of attrSearch2SearchList(seedDetails.season2SearchSc); let key = index">
              <ng-container *ngIf="key > 0">
                ,
              </ng-container>
              <a (click)="attrSeasonOnClick(season)" href="javascript:void(0)">
                {{ season }}
              </a>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="lang === 'en'">
            <ng-container *ngFor="let season of attrSearch2SearchList(seedDetails.season2SearchEn); let key = index">
              <ng-container *ngIf="key > 0">
                ,
              </ng-container>
              <a (click)="attrSeasonOnClick(season)" href="javascript:void(0)">
                {{ season }}
              </a>
            </ng-container>
          </ng-container>
          <!-- <a (click)="attrSpeciesAllOnClick()" href="javascript:void(0)">{{ label[lang].allSpecies }}</a>, -->
          <!-- <a (click)="attrSeasonAllOnClick()" href="javascript:void(0)">{{ label[lang].allSeason }}</a> -->
        </div>

      </div>
      <div class="col-12 col-md-4 order-0 order-md-1">

        <div class="picWrap">

          <!-- <img class="img-fluid mb-4 mx-auto d-block" [src]="src" (click)="openImage(src)"
            *ngFor="let src of seedDetails.images" /> -->

          <ng-container *ngFor="let src of imageListSort(seedDetails.images); let i = index;">
            <img class="img-fluid mb-4 mx-auto d-block" [src]="src" (click)="openImage(src)" *ngIf="i > 0" />
          </ng-container>

          <!-- <img class="img-fluid mb-4 mx-auto d-block" src="https://via.placeholder.com/600x300" (click)="openImage()" />
          <img class="img-fluid mb-4 mx-auto d-block" src="https://via.placeholder.com/600x300" (click)="openImage()" /> -->
        </div>

      </div>
    </div>
    <div class="pb-3">
      <!-- <small>
        {{ label[lang].commonRemark }}
      </small> -->
      <small>{{ label[lang].seedbankRemark1 }}</small>
      <br />
      <small>{{ label[lang].seedbankRemark2 }}</small>
      <br />
      <small>{{ label[lang].seedbankRemark3 }}</small>
    </div>
  </div>

</div>